import { createGlobalStyle } from "styled-components";
import BanerCAC from "../data/img/header_bg.jpg";

const GlobalStyle = createGlobalStyle`
    html {
    overscroll-behavior: none;
    }

    body {
    margin: 0;
    /* background: var(--bgColorABC);
    background-color: var(--bgColorABC); */
    overflow-x: hidden !important;
    overflow: hidden;
/*     transition: background-color 0.5s ease; */
    }
    body,
    tbody {
    &::-webkit-scrollbar {
        width: 11px;
    }
    }
    // Mozilla font size fix

    /* @-moz-document url-prefix() {
    html {
        font-size: 100% !important;
    }
    } */
    body,
    tbody,
    html {
    scrollbar-color: #afafaf #000000;
    }

    body,
    tbody {
        // fix to overlay scrollbar across page
        overflow: overlay;
        }



    body,
    tbody {
    &::-webkit-scrollbar-thumb {
        background-color: var(--scollbarCac);
        border-radius: 0px;
        border: 0px solid var(--scrollbarBG);
        color: var(--thumbBG)
    }
    }

    img {
    opacity: 1;
    /* transition: opacity 0.3s; */
    }

    img[data-srcset] {
    opacity: 0;
    }

    [srcset] {
    opacity: 1;
    /* transition: opacity 0.3s; */
    }

    [data-srcset] {
    opacity: 0;
    }

    #root {
    margin: 0;
    //background: var(--bgcolor);
    /* transition: all 0.2s linear; */
    overflow-x: hidden !important;
    }

    main {
    /* will-change: transform; */
    overflow-x: hidden !important;
    overflow-y: auto;
    }

    a {
    text-decoration: none;
    color: #fce5b9;
    -webkit-transition: all 0.35s ease;
    transition: all 0.35s ease;
    }

    a:not(.btn):hover {
    text-decoration: none;
    color: #fdb448;
    cursor: pointer !important;
    -webkit-transition: all 0.35s ease;
    transition: all 0.35s ease;
    }

    a:focus,
    button:focus,
    input:focus,
    textarea:focus {
    outline: none;
    }

    ::selection {
    color: white;
    background: var(--bgcolor);
    }
    ::-moz-selection {
    color: white;
    background: var(--bgcolor);
    }

    .hidden {
    display: none;
    }

    @media screen and (prefers-reduced-motion: reduce), (update: slow) {
    * {
        animation-duration: 0.001ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: 0.001ms !important;
    }
    }

    #flagz > img,
    #modez,
    #depz,
    #contz,
    #menu-a > a,
    .menu-main,
    #continuesvg:hover,
    #depositsvg:hover {
    transition: all 0.25s ease;
    -webkit-transition: all 0.25s ease;
    z-index: 9991;
    cursor: pointer !important;
    }

    .success-message {
    color: var(--welcomBonusFontColor);
    p {
        color: var(--smallHeaderABC);
    }
    }

    .form-group.required label:after {
    content: '*';
    }

    .hide{
        display: none;
    }
    .mob {
    position: fixed;
    z-index: 1030;
    height: 100%;
    width:100%;
  }
  .overflow-y-body{
    overflow-y: hidden !important;
  }
  /*------------ THEMING ------------- */

  //for safari 15
  /* @media (prefers-color-scheme: light) {
        :root {
            --theme-color: #fff;
        }
    }
    @media (prefers-color-scheme: dark) {
        :root {
            --theme-color: #0a2142;
        }
    } */

    /*---- React carousel arrow position ---- */
    .react-multiple-carousel__arrow--left {
        left: calc(0% + 1px);
    }
    .react-multiple-carousel__arrow--right {
        right: calc(0% + 1px);
    }
    /* Draw the carousel chevrons with CSS instead of the library's "revicons"
       glyphs, so that font is never requested (late, no font-display). */
    .react-multiple-carousel__arrow::before {
        content: "" !important;
        font-family: inherit !important;
        display: block;
        width: 10px;
        height: 10px;
        margin: 0 auto;
        border: solid #fff;
        border-width: 0 2px 2px 0;
    }
    .react-multiple-carousel__arrow--left::before {
        transform: translateX(2px) rotate(135deg);
    }
    .react-multiple-carousel__arrow--right::before {
        transform: translateX(-2px) rotate(-45deg);
    }
    #scroll-to-category-sportsbook, #scroll-to-category-onlogin{
        scroll-margin-top: 70px;
    }
    #scroll-to-category{
        scroll-margin-top: 20px;
    }
    .react-multi-carousel-list{
        padding: 1rem 0;
    }


    :root {
    --acolor: #fff;
    --bgcolor: #1E1D19;
    --headerbg: #1E1D19;
    --lobbybg: #1E1D19;
    --footerbg: #181e52;
    --switchfill: #fff;
    --pcolor: #0e1c81;
    --brandcolor: #fff;
    --paginationHoverColor: #fdb448;
    --smalltext: #2c5194;
    --menuwidth: calc(100vh / 2);
    --footerp: #2c5194;
    --footerh: #fdb448;
    --menuhover: #333333;
    --scrollbarBG: #3a3738;
    --thumbBG: #07415F;
    --menubg: #ebbd00;
    --mainmenu: black;
    --submenu: black;
    --carouseltext: #06005e;
    --showall:#fff;
    --tabletext: #fff;
    --inputtext: #856436;
    --inputphcolor: #0e1c81;
    --selectbg: #302d2e;
    --cookiesbg: #333333;
    --gamebg: #1f1e1ad9;
    --labelcolor: #210091;
    --labelcolordark: #4391ff;
    --bordercolor: rgba(36, 0, 144, 0.1);
    --newsText: #fff;
    --headerbtn: #ffff;
    --icon: #fff;
    --playLive: #333333;
    --icon-bulb: #ae0005;
    --footerColor: #333333;
    --footerBorder: #8564362e;
    --footerTextColor:  #e2e2e2;
    --footerFaderBottom: #1E1D19;
    --stepsColor: #d9efed;
    --stepsActivColor: #fff;
    --bubletop: #e1f4f3;
    --profileMenu: #1E1D19;
    --sideMenu: #161515;
    --progressBar: #eff3f5;
    --buttonFour: #1b0072;
    --profileBtn: #fff;
    --profileBtnHover: #fce5b9;
    --depositBorder: rgba(84, 0, 255, 0.045);
    --customInputColor: #302d2e;
    --BanerBackgroundColor: #e1f4f3;
    --timeLeft: #fff;
    --disabledInputColor: #EFF3F5;
    --registerCalendarColor: #757575;
    --gameSearch: #fff;
    --cookieReverseColor: #fff;
    --cookieLinkColor: #6fa8ff;
    /* StyledCookieConfirmation */
    --cookieConfirmationBorderRadius: 20px;
    --cookieConfirmationRefreshBorderRadius: 0.2rem;
    --cookieConfirmationButtonHoverColor: #fdb448;
    --cookieConfirmationRefreshBg: #212529;
    /* StyledDepositAndWithdrawal */
    --depositCol1Width: 100px;
    --depositCol1Height: unset;
    --depositWrapperButtonWidth: unset;
    --depositRowBg: transparent;
    --depositRowBgDialogOpen: transparent;
    --depositRowBorderRadius: 0;
    --depositRowBorderBottom: none;
    --depositRowTextColor: var(--tabletext);
    --depositRowImgMarginLeft: 0;
    --depositRowButtonMarginRight: 0;
    --depositTextColor: var(--tabletext);
    --depositTextOpacity: 0.4;
    --depositFrameBorderRadius: 0;
    --depositHeadlinePaddingTop: 0;
    --depositHeadlineH3Color: var(--acolor);
    --depositHeadlineH3FontSize: 22px;
    --depositDialogButtonFontSize: 20px;
    --depositDialogButtonBorderRadius: 20px;
    --depositDialogButtonFontWeight: 800;
    --depositDialogLegendMargin: 0;
    --depositDialogButtonPaddingTopSm: 0.75rem;
    --depositDialogButtonPaddingBottomSm: 0.75rem;
    --depositFormGroupMarginBottom: 0;
    /* StyledLimits */
    --limitWrapperPadding: 3rem 0;
    --limitWrapperPaddingMobile: 0 0 1rem 0;
    --limitTimeLimitPaddingBottomDesktop: 0;
    --excludedGamesPaddingTop: 0;
    --excludedGamesBorderBottom: 1px solid var(--bordercolor);
    --cooldownExplanationTopMobile: -100px;
    --fontHoverColorABC: #a18bac;
    --joinCasinoABC : #f4ef00;
    --welcomBonusFontColor : #fdb448;
    --bgColorABC :#333333;
    --bgHederABC : #ffffff6e;
    --borderABC : #dadde624;
    --copyrightABC : #fff;
    --profileBacgroundABC: #EAEBEF;
    --balanceABC: #fff;
    --profileHeaderBgABC: linear-gradient(0deg, rgba(1,20,60,1) 0%, rgba(233,233,233,1) 0%, rgba(1,20,60,0) 0.9%);
    --aboutH2Color: #fff;
    --aboutHeaderColor: #eace9c;
    --paymentHeaderColor: #ffffff52;
    --accountTextShadow:  /* 2px 2px 2px #e6e9ef */;
    --profileCashbackBgABC : linear-gradient(0deg, rgba(1,20,60,1) 0%, rgba(233,233,233,1) 0%, rgba(1,20,60,0) 0.8%);
    --smallHeaderABC: #fff;
    --inputbordercolorABC: #EBECEE;
    --tabletextHoverABC: #353233;
    --inputbgABC: #302D2E;
    --inputbg: #302D2E;
    --mainDescriptionABC: #1E1D19;
    --seoBrecrumbsNavigationBgColor: var(--mainDescriptionABC);
    --categoriesBgLinearABC: #1e1d19;
    --iconbulbABC:#fce5b9;
    --accontFadeCollor: var(--bgcolor);
    --landingBgColor: #11628d;
    --paymentsBg: #fff;
    --profileBubble: #333333;
    --mobileNavBg: #333333;
    --mobileNavActiveBg: #120217f0;
    --navIconColor: #fdb448;
    --subTextColorNav: #6998E0;
    --mobileNavBorder: #cecece38;
    --navBg: linear-gradient(0deg, rgba(255,255,255,1) 76%, rgba(250,250,250,1) 100%);
    --racProfileMenuCol: transparent;
    --cashbackBorderColor: #ffffff4f;
    --termsColor: #76c9f4;
    --scollbarCac: #979797;
    --tournamentBodyInfo: #302d2e;
    --tournamentMoneyBag: #FBA700;
    --tournamentsBorder : #393939;
    --tournamentPastBg: #131212;
    --torunamentPastCardBg: #1E1D19;
    --tournamentDescriptionColor: #AFAFA7;
    --inGameDepositButtonBg: #fdb448;
    --newsTextColor: #fff;
    --newsHeaderColor: #fdb448;
    --mobileNavWrapperBg: #262626a1;
    --mobileProfilHeaderAlign: center;
    --mobileProfilHeaderMargin: 0 auto;
    --mobileProfilHeaderColor: #fff;
    --profileModalWrapperBg: rgba(0, 0, 0, 0.85);
    --profileIconInnerColorActive: #fdb448;
    --profileIconInnerLogoutColor: #fff;
    --profileIconInnerColor: #fdb448;
    --navDepositIconInnerColor: #fdb448;
    --navDepositIconInnerActiveColor: #fdb448;
    --navDepositIconBg: #fff;
    --navDepositIconActiveBg: #333333;
    --navProfileIconLogoutColor: #fff;
    --navProfileIconLogoutActiveColor: #fdb448;
    --headerAndThemeWrapperAlign: space-between;
    --casinobonuses: #fdb448;
    --sportsbonuses: #fdb448;
    --underlineOnIndex: #FDAF1E;
    --quickNavChipActiveColor: #1a1a1a;
    --questionWrapperBg: #e7e7e7;
    --welcomBonusFont: inherit;
    --welcomBonusPadding: 0 10px 30px 10px;
    --calendarButtonColor: #fdb448;
    --emptyCategoryColor: #fdb448;
    --inputRadiusErrorOpen: 30px 30px 0 0;
    /* StyledFooter */
    --footerLinksJustifyWhenAbc: center;
    --footerLinksAnchorPaddingWhenAbc: 20px;
    --footerLinksAnchorColorWhenAbc: var(--footerTextColor);
    --footerLinksWidthAbcextra: 800px;
    --footerLinksMaxWidthAbcextra: 800px;
    --logo18TextColor: #fff;
    --footerButtonColorMobile: #fff;
    --footerBottomBg: var(--footerFaderBottom);
    --footerLinksSectionBg: var(--footerColor);
    --footerTextBodyColor: var(--footerTextColor);
    --footerTextLinkColor: var(--footerTextColor);
    --footerWrapperWidthMobile: 90%;
    --footerWrapperMaxWidth: 1600px;
    --footerWrapperMargin: 2rem auto;
    --footerWrapperBorderRadius: 30px;
    --footerWrapperPaddingTopMobile: 0;
    --footerWrapperPaddingTopTablet: 0;
    --footerWrapperBgGame: var(--gamebg);
    --footerLinksSectionBorderRadius: 30px 30px 0 0;
    --footerLinksWidth: 800px;
    --footerLinksMaxWidth: 800px;
    --footerLinksPadding: 20px;
    --footerLinksDivFontWeight: 600;
    --footerLinksBorderBottom: 1px solid var(--footerTextColor);
    --footerTextWidth: 800px;
    --footerTextMaxWidth: 800px;
    --footerTextMarginDesktop: 40px auto;
    --footerTextMarginMobile: 40px auto;
    --footerTextPadding: 0 20px 0 0;
    --footerTextHeight: 200px;
    --footerTextScrollbarColor: #afafaf #000000;
    --footerTextScrollbarThumb: #AAA2A5;
    --footerTextPaddingMobile: 1rem;
    --footerTrustlyWidth: 800px;
    --footerTrustlyMaxWidth: 800px;
    --footerTrustlyPaddingMobile: 0 10px;
    --footerLicencesPadding: 4rem 0 0 0;
    --footerLicencesJustifyContent: center;
    --footerLicencesJustifyMobile: space-around;
    --footerLicencesMaxWidth: 1200px;
    --footerLicencesBorderBottomDesktop: 1px solid var(--footerBorder);
    --footerLicencesBorderBottomMobile: 1px solid var(--footerBorder);
    --footerLicencesDivMargin: 10px;
    --footerCopyrightFontSize: 0.83rem;
    --footerPaymentWrapperMinHeight: 120px;
    --footerPaymentAlignItems: baseline;
    --footerPaymentJustifyContent: inherit;
    --footerPaymentMaxWidth: 1130px;
    --footerPaymentMinHeight: 100%;
    --footerLinksWidthTablet: 90%;
    --footerLicencesStFill: #fff;
    --footerLicencesCls1Fill: #fff;
    --footerWrapperPaddingTopMobile: 0;
    --footerWrapperPaddingTopTablet: 0;

    --styledTabActiveBgColor: transparent;
    /* AccountPage - Batch 1 */
    --accountHeaderTextTransform: uppercase;
    /* AccountPage - Batch 2 */
    --accountColTextTransform: uppercase;
    --gameTransactionWrapperAlignItems: baseline;
    --previousTournamentsWrapperWidth: 90%;
    --previousTournamentsWrapperMargin: auto;
    --previousTournamentsWrapperBorderRadius: 35px;
    --previousTournamentsHeaderColor: var(--tournamentDescriptionColor);
    --previousTournamentsHeaderTextAlign: center;
    --prizePoolSecondStyleBorderRadius: 20px;
    --tournamentGameDescriptionMargin: 5rem 0;
    --tournamentGameDescriptionPosition: static;
    --tournamentsBodyCardContentBorderRight: 2px solid #393939;
    --tournamentsBodyCardContentMargin: 2rem 0;
    --tournamentsBodyCardContentPColor: var(--tournamentDescriptionColor);
    --tournamentsBodyCardDateTextAlign: left;
    --tournamentsBodyCardDateLastChildWidth: 80%;
    --tournamentsBodyInfoBorderRadius: 24px;
    --tournamentsBodyInfoJustifyContent: right;
    --tournamentsBodyInfoFlexWrap: wrap;
    --styledFormWrapperTextTransform: capitalize;
    --styledFormLastRowTextTransform: capitalize;
    --styledFormLastRowSelectHeight: 65px;
    --transactionsButtonWrapperBorderBottom: 2px solid var(--progressBar);
    --accountDescriptionColor: var(--smallHeaderABC);
    --accountDescriptionH5Color: var(--smallHeaderABC);
    --accountDescriptionH5Bg: -webkit-linear-gradient(var(--smallHeaderABC), var(--accontFadeCollor) 50%);
    --accountDescriptionMobileOverflow: hidden;
    --accountDescriptionAccordionHoverColor: #fdb448;
    --accountDescriptionH4Color: #fdb448;
    --accountDescriptionH2Padding: 1rem 0;
    --accountDescriptionLiFontSize: 1rem;
    --accountCustomFormInlineMargin: 0 0 2rem 0;
    --accountCustomFormInlinePadding: 0 0 1rem 0;
    --accountCustomFormInlineMobileMargin: 0;
    --textBottomOpenMarginBottom: 100px;
    --textBottomH2TextTransform: uppercase;
    --textBottomH3Margin: 1rem 0;
    --pageContentWrapperFormGroupMb: 0;
    --accountContainerMarginBottom: 2rem;
    --tournamentsBodyCardScrollbarThumbColor: #AAA2A5;
    --textPageH2MediaMarginTop: 140px;
    --textPageH2MediaLetterSpacing: 7px;
    /* AccountPage - Batch 3 */
    --styledPageHeaderWrapperAHoverBg: transparent;
    --styledFormWrapperEditBorderBottom: 1px solid #ae0005;
    --styledFormWrapperSpanBorderBottom: 1px solid var(--footerBorder);
    --styledFormLastRowDisabledBorderBottom: 1px solid var(--footerBorder);
    --styledFormLastRowNotEditBorderBottom: 1px solid #ae0005;
    --styledFormLastRowEditBorderBottom: 1px solid var(--footerBorder);
    --myProfileButtonBgColor: #fdb448;
    --myProfileButtonColor: #1b1b1b;
    --myProfileButtonHoverColor: #1b1b1b;
    --myProfileButtonBorderRadius: 30px;
    --styledFormWrapperInputWidth: 100%;
    --styledFormWrapperLabelColor: inherit;
    --styledFormWrapperLabelFontWeight: inherit;
    /* AccountPage - Batch 4 */
    --pageContentBgPosition: center;
    --pageContentBgSizeDep: cover;
    --pageContentBgBgColor: var(--headerbg);
    --pageContentWrapperBtnPaddingRight: 15px;
    /* AccountPage - Batch 5 */
    --pageContentHeaderAboutBgColor: var(--bgcolor);
    --pageContentHeaderAccountBgColor: var(--bgcolor);
    --pageContentHeaderMobileBgColor: var(--bgcolor);
    --pageContentHeaderBgColor: var(--bgcolor);
    --pageContentMinHeight: calc(100vh - 560px);
    --pageContentBgAlignItems: center;
    --pageContentBgMinHeightLand: 100vh;
    --pageContentBgMinHeight: 100vh;
    --pageContentBgMinHeightMobile: 100vh;
    --tabContentLiColor: var(--tabletext);
    --accountDescriptionPAboutColor: var(--acolor);
    --accountDescriptionPColor: var(--acolor);
    --accountDescriptionH2FontFamily: inherit;
    --accountDescriptionExpandHeight: 100%;
    --accountDescriptionCollapsedHeight: 60px;
    --transactionDescriptionPadding: 1rem;
    --transactionDescriptionPFontSize: inherit;
    --transactionDescriptionPColor: var(--smallHeaderABC);
    --transactionDescriptionAffeddFontSize: 1.2rem;
    --transactionDescriptionPFontWeight: normal;
    --textPageMargin: 3rem auto;
    --textPageMobileMargin: 3rem auto;
    --textPageH2PaymentsColor: var(--footerh);
    --textPageH2Color: var(--footerh);
    --tournamentsBodyCardMargin: 1rem 2rem;
    --tournamentsBodyCardBorderSecondStyle: 2px solid var(--tournamentsBorder);
    --tournamentsBodyCardBorderBottom: 2px solid var(--tournamentsBorder);
    --tournamentsBodyCardLeaderboardBg: var(--tournamentBodyInfo);
    --accountContainerMtMarginTop: 20vh;
    --accountContainerLimitsBtnMargin: 1rem 15px;
    --accountContainerInputFontWeight: 400;
    --accountContainerInputHeight: 65px;
    --accountContainerDisabledTextColor: #fff;
    --accountContainerInvalidFeedbackPosition: absolute;
    --accountContainerInvalidFeedbackTop: 3rem;
    --accountContainerMobilePaddingInline: 10px;
    --accountContainerLabelFontWeight: 400;
    --accountContainerSpanColor: #fff;
    /* AccountPage - Batch 7 */
    --accountContainerContainerExtraMargin: 8rem 0 2rem 0;
    --styledFormWrapperPadding: 0 !important;
    --styledTabListMarginTop: 3rem;
    --styledTableRowBorderBottom: 1px solid rgba(218, 221, 230, 0.1411764706);
    --pageContentBgPositionDep: var(--pageContentBgPosition);
    --pageContentBgPaymentsBgColor: var(--pageContentBgBgColor);
    --pageContentBgImageAccount: url(${BanerCAC});
    --pageContentBgImageBg: url(${BanerCAC});
    --pageContentBgPubBg: var(--pageContentBgImageBg);
    --pageContentBgPubClearBg: var(--pageContentBgImageBg);
    /* PageContent */
    --pageContentBgImageIngamedepMobile: none;
    /* SupportLink */
    --supportLinkBgColor: #fdb448;
    --supportLinkPhoneBgColor: var(--menuhover);
    --supportLinkBorderRadius: 30px;
    --supportLinkColor: #fff;
    --supportLinkPhoneColor: #fff;
    --supportLinkPadding: 0.6rem 1.5rem;
    --supportLinkHoverColor: #fff !important;
    --supportLinkHoverBgColor: #b17c2f;
    --supportLinkPhoneHoverBgColor: #322d2e;
    --supportLinkPhoneBeforeContent: none;
    --supportLinkEmailBeforeContent: none;
    --supportLinkBeforeContent: none;
    /* SupportButtonsWrapper */
    --supportButtonsWrapperPaddingTop: 10rem !important;
    /* SupportDiv */
    --supportDivSpanColor: #fff;
    --supportDivSpanHoverColor: inherit;
    /* StyledGamesHeader */
    --styledGamesHeaderBgColor: var(--headerbg);
    --styledGamesHeaderBgImage: url(${BanerCAC});
    --styledGamesHeaderBgImageAccount: url(${BanerCAC});
    --styledGamesHeaderBgSize: 100%, contain;
    --styledGamesHeaderBgSizeMobile: auto;
    --styledGamesHeaderBgSizeAccount: cover;
    --styledGamesHeaderHeightAccount: 340px;
    --styledGamesHeaderHeightAccountTabletLandscape: 450px;
    --styledGamesHeaderHeight: 300px;
    --styledGamesHeaderHeightSupport: 300px;
    --styledGamesHeaderHeightMobileAccount: 570px;
    --styledGamesHeaderHeightMobileSupport: 530px;
    --styledGamesHeaderHeightMobileCategory: 120px;
    --styledGamesHeaderHeightMobileDefault: 110px;
    --styledGamesHeaderHeightMobileRoute: 100px;
    --styledGamesHeaderHeightMobileCompact: 120px;
    --styledGamesHeaderHeightMobileLandscapeAccount: 480px;
    --styledGamesHeaderHeightMobileLandscapeSupport: 350px;
    --styledGamesHeaderHeightTabletRoute: 250px;
    --styledGamesHeaderHeightTabletAccount: 500px;
    --styledGamesHeaderHeightTabletAccountCompact: 500px;
    --styledGamesHeaderHeightTabletSupport: 400px;
    --styledGamesHeaderHeightTabletDefault: 250px;
    
    /* StyledGame - GameProvider */
    --gameProviderWrapperJustifyMd: center;
    --gameProviderExtendJustifyMd: space-between;
    --gameProviderColPosition: relative;
    --gameProviderColWidth: 100%;
    --gameProviderColFlexBasis: 0;
    --gameProviderColFlexGrow: 1;
    --gameProviderColMaxWidth: 100%;
    --gameProviderColPadding: 0;
    --gameProviderColFlexSm: 0 0 100%;
    --gameProviderColMaxWidthSm: 100%;
    --gameProviderColFlexLg: 0 0 58.333333%;
    --gameProviderColMaxWidthLg: 58.333333%;
    --gameProviderExtendImgMargin: 20px;
    --gameProviderExtendImgHoverBoxShadow: 0 0 11px rgba(146, 146, 146, 0.2);
    --styledProviderLogoMargin: 70px auto;
    --gameProviderH3Color: var(--brandcolor);
    --gameProviderH3FontSize: 1.5rem;
    --gameProviderH3FontWeight: 800;
    
    
    /* StyledGamesCategories */
    --gamesCategoriesMobileFilterLabelColor: var(--tabletext);
    --gamesCategoriesMobileFilterOptionBg: var(--lobbybg);
    --gamesCategoriesMobileFilterOptionColor: var(--tabletext);
    --gamesCategoriesMobileFilterSelectFocusBg: var(--lobbybg);
    --gamesCategoriesSearchWrapperMargin: 0 0 2rem 0;
    --gamesCategoriesSearchLabelWidth: 370px;
    --gamesCategoriesSearchLabelAutofillColor: var(--acolor);
    --gamesCategoriesSearchInputBorderRadius: 30px;
    --gamesCategoriesSearchInputBorder: 1px solid #979797;
    --gamesCategoriesSearchInputHeight: 62px;
    --gamesCategoriesSearchInputPadding: 10px 20px;
    --gamesCategoriesSearchInputBg: transparent;
    --gamesCategoriesSearchInputPlaceholderColor: var(--showall);
    --gamesCategoriesListGroupBg: var(--bgcolor);
    --gamesCategoriesListGroupMaxWidth: 370px;
    --gamesCategoriesListGroupScrollbarTrackBg: var(--bgcolor);
    --gamesCategoriesListGroupScrollbarTrackRadius: 0.3rem;
    --gamesCategoriesListGroupScrollbarThumbBg: var(--scollbarCac);
    --gamesCategoriesListGroupItemColor: var(--tabletext);
    --gamesCategoriesListGroupItemBg: var(--bgcolor);
    --gamesCategoriesFilterBtnColor: #fff;
    --gamesCategoriesFilterBtnColorOpened: #fff;
    --gamesCategoriesFilterBtnFontWeight: 700;
    --gamesCategoriesFilterBtnTextTransform: capitalize;
    --gamesCategoriesFilterBtnBgOpened: var(--menuhover);
    --gamesCategoriesFilterBtnBorderRadiusOpened: 28px;
    --gamesCategoriesFilterBtnBorderOpened: none;
    --gamesCategoriesFilterBtnPaddingTablet: 12px;
    --gamesCategoriesFilterBtnPadding: 10px 20px;
    --gamesCategoriesFilterBtnFontSizeTablet: 0.6rem;
    --gamesCategoriesQuickCategoriesPosition: absolute;
    --gamesCategoriesQuickCategoriesLeft: 50%;
    --gamesCategoriesQuickCategoriesTransform: translateX(-50%);
    --gamesCategoriesQuickCategoriesFontSize: 0.8rem;
    --gamesCategoriesQuickCategoriesFontSizeMobile: 1rem;
    --royale99ButtonBorderColor: #fff;
    --royale99SectionTitleColor: var(--tabletext);
    --royale99HowToCardBg: var(--bgColorABC);
    --royale99HowToStepBg: var(--headerbg);
    --royale99HowToStepColor: var(--tabletext);
    --royale99PlayNowBg: #90b55a;
    --royale99PlayNowBorder: none;
    --royale99PlayNowRadius: 30px;
    --royale99PlayNowColor: #fff;
    --royale99PlayNowHoverBg: #7a9b4c;
    --royale99PlayNowHoverColor: #fff;
    --royale99HowToPlayBg: transparent;
    --royale99HowToPlayBorder: 1px solid #979797;
    --royale99HowToPlayRadius: 30px;
    --royale99HowToPlayColor: #fff;
    --royale99HowToPlayHoverBg: #333;
    --royale99HowToPlayHoverColor: #fff;
    --wrapperLinkLiveCasino: #90b55a;
    --gamesCategoriesSearchWrapperMarginMobile: 0 0 2rem 0;
    --gamesCategoriesSearchInputPaddingMobile: 10px 20px;
    --gamesCategoriesQuickCategoriesPositionMd: absolute;
    --gamesCategoriesQuickCategoriesLeftMd: 50%;
    --gamesCategoriesQuickCategoriesTransformMd: translateX(-50%);
    --gamesCategoriesQuickCategoriesMaxWidth: calc(100vw - 560px);

    /* ContentTopWrapper */
    --contentTopWrapperLinkColor: var(--acolor);
    --contentTopWrapperLinkColorMobile: var(--acolor);
    --contentTopWrapperMobileMaxWidthMobile: 555px;
    --contentTopWrapperDesktopMenuBg: var(--profileMenu);
    --contentTopWrapperDesktopMenuLinkColor: var(--profileBtn);
    --contentTopWrapperDesktopMenuLinkHoverColor: var(--profileBtnHover);
    --contentTopWrapperTabletMarginTop: 40px;
    --contentTopWrapperTabletLandscapeMarginTop: 35px;
    --contentTopWrapperMobileActiveColor: #fff;
    --contentTopWrapperMobileLinkFontSize: 0.6rem;
    --contentTopWrapperMobileMaxWidth: 555px;
    --contentTopWrapperMobileLandscapeLinkFontSize: 0.5rem;
    --contentTopWrapperDesktopMenuBorderRadius: 20px;
    --contentTopWrapperDesktopMenuBorder: 1px solid #424141;
    /* ProfileMenuWrapper */
    --profileMenuWrapperTop: 160px;
    --profileMenuWrapperTopSearch: 240px;
    --profileMenuWrapperTopMobile: 160px;
    --profileMenuWrapperTopTablet: 150px;
    --profileMenuWrapperListGroupBoxShadow: 0px 0px 10px -2px var(--profileMenu);
    --profileMenuWrapperListGroupMarginTop: 10px;
    --profileMenuWrapperListGroupBorder: 1px solid #424141;
    /* AccountHeader / AboutHeader / ContentCard */
    --aboutHeaderFontFamily: inherit;
    --aboutHeaderFontWeight: 900;
    --aboutHeaderTextTransform: uppercase;
    --aboutHeaderFontSize: 180px;
    --aboutHeaderHeight: 300px;
    --aboutHeaderHeightMobile: 300px;
    --aboutHeaderPaddingTop: 2rem;
    --aboutHeaderTextColor: var(--aboutHeaderColor);
    --aboutHeaderFontSizeMobile: 14.5vw;
    --aboutHeaderFontSizeMobilePayments: 18vw;
    --contentCardSizeMobile: 80px;
    --contentCardSizeDesktop: 80px;
    --profileHeaderBg: var(--profileHeaderBgABC);
    /* StyledContentTop - Batch 7 */
    --profilePubIconCircleFill: #000;
    --profilePubIconCircleOpacity: 0.5970279;
    --profilePubIconCircleFillOpacity: 0.20648;
    --profilePubIconCircleStroke: transparent;
    --profilePubIconMaskFill: #fff;
    --profilePubIconMaskFillCashback: #fff;
    /* StyledActiveBonus */
    --activeBonusColumnBorderBottom: 2px solid var(--progressBar);
    --activeBonusColumnPadding: 0;
    --activeBonusColumnPaddingBottom: 1rem;
    --styledRowSelectColor: #fff;
    /* DescriptionPages */
    --descriptionHeaderTextTransform: uppercase;
    --nextButtonFontSize: 12px;
    --newsArticleBorderBottom: 1px solid var(--footerBorder);
    --newsArticleImageBorderRadius: 1rem;
    --newsTitleH3FontWeight: 800;
    --newsTitleH3Color: var(--acolor);
    --newsTextPFontSize: 1.1rem;
    --newsTextPColor: var(--acolor);
    --buttonReadMoreTextAlign: right;
    --buttonReadMoreFontSize: 1rem;
    --buttonReadMoreColor: var(--acolor) !important;
    --buttonReadMoreBorderRadius: 0;
    /* CommonStyledComponents */
    --styledLinkGamesearchColor: var(--tabletext);
    --styledLinkGamesearchBgColor: var(--bgcolor);
    --styledLinkGotogamesFontSize: 1rem;
    --styledLinkSlidcontrollFontSize: 1.3rem;
    --styledLinkSlidcontrollPadding: 15px 20px !important;
    --styledLinkSlidcontrollColor: inherit;
    --styledLinkSlidcontrollMobileFontSize: 1rem;
    --styledLinkSlidcontrollMobilePadding: 15px 20px !important;
    --styledLinkSlidcontrollBorder: none;
    --styledLinkSlidcontrollBorderRadius: 30px;
    --styledLinkSlidcontrollBgColor: #fdb448;
    --styledLinkSlidcontrollBgColor: #fdb448;
    --styledLinkSlidcontrollWidth: auto;
    --styledLinkSlidcontrollHoverBorderColor: inherit;
    --styledLinkSlidcontrollHoverBgColor: #edab49;
    --styledLinkSlidcontrollMobileMarginLeft: 0;
    --styledNavLinkActiveDivSvgFill: transparent;
    --styledNavLinkMaskFillColor: #fff;
    --styledNavLinkJustifyContent: normal;
    --styledNavLinkFontWeight: 400;
    --styledNavLinkDivBorderRadius: 50%;
    --styledNavLinkDivBorder: 1px solid #979797;
    --styledNavLinkBackgroundImage: none;
    --styledNavLinkActiveDivBgColor: transparent;
    --styledNavLinkActiveDivBorder: 2px solid #fdb448;
    --styledNavLinkActiveDivBorderRadius: 50%;
    --styledButtonSearchButtonTop: 0.8rem;
    --styledButtonSearchButtonRight: 1rem;
    --styledButtonSearchButtonColor: var(--gameSearch);
    --styledButtonSearchButtonMobileTop: 0.8rem;
    --styledButtonSearchButtonMobileRight: 1rem;
    --styledButtonSupportChatPadding: 0.5rem 1rem;
    --styledButtonSupportChatBorder: none;
    --styledButtonSupportChatBgColor: #fdb448;
    --styledButtonSupportChatBorderRadius: 30px;
    --styledButtonSupportChatColor: #fff !important;
    --styledButtonSupportChatHoverBgColor: #b17c2f;
    --styledButtonSupportChatBeforeContent: none;
    --styledLinkLimitsColor: inherit;
    --styledButtonSupportChatDivColor: #fff !important;
    --styledButtonSupportChatBeforeColor: inherit;
    --styledInputEmailTextTransform: lowercase !important;
    --visibilityIconTop: -40px;
    --visibilityIconColorLight: #fff;
    --visibilityIconColorDark: #fff;
    --accountDescriptionMargin: 2rem auto;
    --transactionButtonBorderRadius: var(--myProfileButtonBorderRadius);
    --gameTransactionButtonBorderRadius: var(--myProfileButtonBorderRadius);
    --birthdayWrapperPaddingTop: 0.8rem;
    --birthdayWrapperColor: #fff;
    --styledDatePickerCalendarBg: var(--inputbg);
    --styledDateRangePickerCalendarBg: var(--inputbg);
    --styledLinkLimitsColor: #fdb448;
    --styledGamesHeaderBgSizeSupport: cover;
    --pageContentBgSizeBgDesktop: cover;
    --pageContentBgSizeBgMobile: cover;
    --gamesCategoriesQuickCategoriesLinkHoverColor: #fdb448;



    }

    [data-theme='dark'] {
    --acolor: white;
    --bgcolor: #1E1D19;
    --bgColorABC: #333333;
    --headerbg: #1E1D19;
    --lobbybg: #1E1D19;
    --footerbg: #181e52;
    --brandcolor: #fff;
    --paginationHoverColor: #fdb448;
    --switchfill: #fff;
    --pcolor: #858585;
    --footerp: #819ad7;
    --footerh: #fdb448;
    --menuhover: #333333;
    --scrollbarBG: #8564362e;
    --thumbBG: #07415F;
    --menubg: #070911;
    --mainmenu: white;
    --submenu: #62789d;
    --carouseltext: #4d79ff;
    --showall: #fff;
    --tabletext: #fff;
    --inputtext: #856436;
    --inputphcolor: #fff;
    --selectbg: #302d2e;
    --cookiesbg: #333333;
    --gamebg: #1f1e1ad9;
    --labelcolor: #fff;
    --labelcolordark: #4391ff;
    --bordercolor: rgba(255, 255, 255, 0.1);
    --newsText: #fff;
    --headerbtn: #fff;
    --icon: #fff;
    --playLive: #333333;
    --icon-bulb: #fff;
    --footerColor: #333333;
    --footerBorder: #8564362e;
    --footerFaderBottom: #1E1D19;
    --stepsColor: #50505f;
    --stepsActivColor: #000016;
    --bubletop: #000016;
    --profileMenu: #1E1D19;
    --sideMenu: #161515;
    --progressBar: #162f4f;
    --buttonFour: #212529;
    --profileBtn: #5c80b3;
    --profileBtnHover: #fff;
    //--depositBorder: rgba(77,121,255,.1);
    --depositBorder: rgba(255, 255, 255, 0.15);
    --customInputColor: #302d2e;
    --BanerBackgroundColor: #000016;
    --timeLeft: #fff;
    --disabledInputColor: #1a1a2d;
    --registerCalendarColor: white;
    --gameSearch: #fff;
    --footerTextColor: #D7DBDF;
    --cookieReverseColor: #c4b3cd;
    --cookieLinkColor: #6fa8ff;
    /* StyledCookieConfirmation */
    --cookieConfirmationBorderRadius: 20px;
    --cookieConfirmationRefreshBorderRadius: 0.2rem;
    --cookieConfirmationButtonHoverColor: #fdb448;
    --cookieConfirmationRefreshBg: #212529;
    /* StyledDepositAndWithdrawal */
    --depositCol1Width: 100px;
    --depositCol1Height: unset;
    --depositWrapperButtonWidth: unset;
    --depositRowBg: transparent;
    --depositRowBgDialogOpen: transparent;
    --depositRowBorderRadius: 0;
    --depositRowBorderBottom: none;
    --depositRowTextColor: var(--tabletext);
    --depositRowImgMarginLeft: 0;
    --depositRowButtonMarginRight: 0;
    --depositTextColor: var(--tabletext);
    --depositTextOpacity: 0.4;
    --depositFrameBorderRadius: 0;
    --depositHeadlinePaddingTop: 0;
    --depositHeadlineH3Color: var(--acolor);
    --depositHeadlineH3FontSize: 22px;
    --depositDialogButtonFontSize: 20px;
    --depositDialogButtonBorderRadius: 20px;
    --depositDialogButtonFontWeight: 800;
    --depositDialogLegendMargin: 0;
    --depositDialogButtonPaddingTopSm: 0.75rem;
    --depositDialogButtonPaddingBottomSm: 0.75rem;
    --depositFormGroupMarginBottom: 0;
    /* StyledLimits */
    --limitWrapperPadding: 3rem 0;
    --limitWrapperPaddingMobile: 0 0 1rem 0;
    --limitTimeLimitPaddingBottomDesktop: 0;
    --excludedGamesPaddingTop: 0;
    --excludedGamesBorderBottom: 1px solid var(--bordercolor);
    --cooldownExplanationTopMobile: -100px;
    --fontHoverColorABC: #fff;
    --joinCasinoABC : #f4ef00;
    --welcomBonusFontColor : #fdb448;
    --bgHederABC : #ffffff6e;
    --borderABC : #0e214b;
    --copyrightABC : #fff;
    --profileBacgroundABC: #0554b3;
    --profileHeaderBgABC: linear-gradient(
    0deg,
    rgba(1, 20, 60, 1) 0%,
    rgba(43, 68, 121, 1) 0%,
    rgba(1, 20, 60, 0) 3%
  );
    
    
    /* StyledGamesCategories */
    --gamesCategoriesMobileFilterLabelColor: var(--tabletext);
    --gamesCategoriesMobileFilterOptionBg: var(--lobbybg);
    --gamesCategoriesMobileFilterOptionColor: var(--tabletext);
    --gamesCategoriesMobileFilterSelectFocusBg: var(--lobbybg);
    --gamesCategoriesSearchWrapperMargin: 0 0 2rem 0;
    --gamesCategoriesSearchLabelWidth: 370px;
    --gamesCategoriesSearchLabelAutofillColor: var(--acolor);
    --gamesCategoriesSearchInputBorderRadius: 30px;
    --gamesCategoriesSearchInputBorder: 1px solid #979797;
    --gamesCategoriesSearchInputHeight: 62px;
    --gamesCategoriesSearchInputPadding: 10px 20px;
    --gamesCategoriesSearchInputBg: transparent;
    --gamesCategoriesSearchInputPlaceholderColor: var(--showall);
    --gamesCategoriesListGroupBg: var(--bgcolor);
    --gamesCategoriesListGroupMaxWidth: 370px;
    --gamesCategoriesListGroupScrollbarTrackBg: var(--bgcolor);
    --gamesCategoriesListGroupScrollbarTrackRadius: 0.3rem;
    --gamesCategoriesListGroupScrollbarThumbBg: var(--scollbarCac);
    --gamesCategoriesListGroupItemColor: var(--tabletext);
    --gamesCategoriesListGroupItemBg: var(--bgcolor);
    --gamesCategoriesFilterBtnColor: #fff;
    --gamesCategoriesFilterBtnColorOpened: #fff;
    --gamesCategoriesFilterBtnFontWeight: 700;
    --gamesCategoriesFilterBtnTextTransform: capitalize;
    --gamesCategoriesFilterBtnBgOpened: var(--menuhover);
    --gamesCategoriesFilterBtnBorderRadiusOpened: 28px;
    --gamesCategoriesFilterBtnBorderOpened: none;
    --gamesCategoriesFilterBtnPaddingTablet: 12px;
    --gamesCategoriesFilterBtnPadding: 10px 20px;
    --gamesCategoriesFilterBtnFontSizeTablet: 0.6rem;
    --gamesCategoriesQuickCategoriesPosition: absolute;
    --gamesCategoriesQuickCategoriesLeft: 50%;
    --gamesCategoriesQuickCategoriesTransform: translateX(-50%);
    --gamesCategoriesQuickCategoriesFontSize: 0.8rem;
    --gamesCategoriesQuickCategoriesFontSizeMobile: 1rem;
    --royale99ButtonBorderColor: #fff;
    --royale99SectionTitleColor: var(--tabletext);
    --royale99HowToCardBg: var(--bgColorABC);
    --royale99HowToStepBg: var(--headerbg);
    --royale99HowToStepColor: var(--tabletext);
    --royale99PlayNowBg: #90b55a;
    --royale99PlayNowBorder: none;
    --royale99PlayNowRadius: 30px;
    --royale99PlayNowColor: #fff;
    --royale99PlayNowHoverBg: #7a9b4c;
    --royale99PlayNowHoverColor: #fff;
    --royale99HowToPlayBg: transparent;
    --royale99HowToPlayBorder: 1px solid #979797;
    --royale99HowToPlayRadius: 30px;
    --royale99HowToPlayColor: #fff;
    --royale99HowToPlayHoverBg: #333;
    --royale99HowToPlayHoverColor: #fff;
    --wrapperLinkLiveCasino: #90b55a;
    --gamesCategoriesSearchWrapperMarginMobile: 0 0 2rem 0;
    --gamesCategoriesSearchInputPaddingMobile: 10px 20px;
    --gamesCategoriesQuickCategoriesPositionMd: absolute;
    --gamesCategoriesQuickCategoriesLeftMd: 50%;
    --gamesCategoriesQuickCategoriesTransformMd: translateX(-50%);
    --gamesCategoriesQuickCategoriesMaxWidth: calc(100vw - 560px);

    /* StyledFooter */
    --footerTextLinkColor: var(--footerTextColor);
    --footerTextBodyColor: var(--footerTextColor);
    --footerLinksJustifyWhenAbc: center;
    --footerLinksAnchorPaddingWhenAbc: 20px;
    --footerLinksAnchorColorWhenAbc: var(--footerTextColor);
    --footerLinksWidthAbcextra: 800px;
    --footerLinksMaxWidthAbcextra: 800px;
    --logo18TextColor: #fff;
    --footerButtonColorMobile: #fff;
    --footerWrapperWidthMobile: 90%;
    --footerWrapperMaxWidth: 1600px;
    --footerWrapperMargin: 2rem auto;
    --footerWrapperBorderRadius: 30px;
    --footerWrapperPaddingTopMobile: 0;
    --footerWrapperPaddingTopTablet: 0;
    --footerWrapperBgGame: var(--gamebg);
    --footerLinksSectionBorderRadius: 30px 30px 0 0;
    --footerLinksWidth: 800px;
    --footerLinksMaxWidth: 800px;
    --footerLinksPadding: 20px;
    --footerLinksDivFontWeight: 600;
    --footerLinksBorderBottom: 1px solid var(--footerTextColor);
    --footerTextWidth: 800px;
    --footerTextMaxWidth: 800px;
    --footerTextMarginDesktop: 40px auto;
    --footerTextMarginMobile: 40px auto;
    --footerTextPadding: 0 20px 0 0;
    --footerTextHeight: 200px;
    --footerTextScrollbarColor: #afafaf #000000;
    --footerTextScrollbarThumb: #AAA2A5;
    --footerTextPaddingMobile: 1rem;
    --footerTrustlyWidth: 800px;
    --footerTrustlyMaxWidth: 800px;
    --footerTrustlyPaddingMobile: 0 10px;
    --footerLicencesPadding: 4rem 0 0 0;
    --footerLicencesJustifyContent: center;
    --footerLicencesJustifyMobile: space-around;
    --footerLicencesMaxWidth: 1200px;
    --footerLicencesBorderBottomDesktop: 1px solid var(--footerBorder);
    --footerLicencesBorderBottomMobile: 1px solid var(--footerBorder);
    --footerLicencesDivMargin: 10px;
    --footerCopyrightFontSize: 0.83rem;
    --footerPaymentWrapperMinHeight: 120px;
    --footerPaymentAlignItems: baseline;
    --footerPaymentJustifyContent: inherit;
    --footerPaymentMaxWidth: 1130px;
    --footerPaymentMinHeight: 100%;
    --footerLinksWidthTablet: 90%;
    --footerLicencesStFill: #fff;
    --footerLicencesCls1Fill: #fff;
    --footerWrapperPaddingTopMobile: 0;
    --footerWrapperPaddingTopMobile: 0;
    --footerWrapperPaddingTopTablet: 0;
    
    /* StyledGame - GameProvider */
    --gameProviderWrapperJustifyMd: center;
    --gameProviderExtendJustifyMd: space-between;
    --gameProviderColPosition: relative;
    --gameProviderColWidth: 100%;
    --gameProviderColFlexBasis: 0;
    --gameProviderColFlexGrow: 1;
    --gameProviderColMaxWidth: 100%;
    --gameProviderColPadding: 0;
    --gameProviderColFlexSm: 0 0 100%;
    --gameProviderColMaxWidthSm: 100%;
    --gameProviderColFlexLg: 0 0 58.333333%;
    --gameProviderColMaxWidthLg: 58.333333%;
    --gameProviderExtendImgMargin: 20px;
    --gameProviderExtendImgHoverBoxShadow: 0 0 11px rgba(146, 146, 146, 0.2);
    --styledProviderLogoMargin: 70px auto;
    --gameProviderH3Color: var(--brandcolor);
    --gameProviderH3FontSize: 1.5rem;
    --gameProviderH3FontWeight: 800;
    --balanceABC: #fff;
    --aboutH2Color: #ffffff;
    --aboutHeaderColor: #eace9c;
    --paymentHeaderColor: #030d31;
    --accountTextShadow:  2px 2px 2px #0A1849;
    --profileCashbackBgABC : linear-gradient(
    0deg,
    rgba(1, 20, 60, 1) 0%,
    rgba(43, 68, 121, 1) 0%,
    rgba(1, 20, 60, 0) 1.5%
    );
    --smallHeaderABC: #fff;
    --inputbordercolorABC: #070A29;
    --tabletextHoverABC: #353233;
    --inputbgABC: #302D2E;
    --inputbg: #302D2E;
    --mainDescriptionABC: #1E1D19;
    --seoBrecrumbsNavigationBgColor: var(--mainDescriptionABC);
    --categoriesBgLinearABC: #1e1d19;
    --iconbulbABC: #fce5b9;
    --accontFadeCollor: var(--bgcolor);
    --landingBgColor: #11628d;
    --paymentsBg: #010522;
    --profileBubble: #333333;
    --mobileNavBg:#333333;
    --mobileNavActiveBg: #01143c;
    --navIconColor:  #fdb448;
    --subTextColorNav: #fff;
    --mobileNavBorder: #cecece38;
    --navBg: linear-gradient(0deg, rgba(1,20,60,1) 76%, rgba(2,26,77,1) 100%);
    --racProfileMenuCol: transparent;
    --cashbackBorderColor: #ffffff4f;
    --scollbarCac: #979797;
    --tournamentBodyInfo: #302d2e;
    --inGameDepositButtonBg: #fdb448;
    --newsTextColor: #fff;
    --newsHeaderColor: #fdb448;
    --mobileNavWrapperBg: #262626a1;
    --mobileProfilHeaderAlign: center;
    --mobileProfilHeaderMargin: 0 auto;
    --mobileProfilHeaderColor: #fff;
    --profileModalWrapperBg: rgba(0, 0, 0, 0.85);
    --profileIconInnerColorActive: #fdb448;
    --profileIconInnerLogoutColor: #fff;
    --profileIconInnerColor: #fdb448;
    --navDepositIconInnerColor: #fdb448;
    --navDepositIconInnerActiveColor: #fdb448;
    --navDepositIconBg: #fff;
    --navDepositIconActiveBg: #333333;
    --navProfileIconLogoutColor: #fff;
    --navProfileIconLogoutActiveColor: #fdb448;
    --headerAndThemeWrapperAlign: space-between;
    --casinobonuses: #fdb448;
    --sportsbonuses: #fdb448;
    --underlineOnIndex: #FDAF1E;
    --quickNavChipActiveColor: #1a1a1a;
    --questionWrapperBg: #e7e7e7;
    --calendarButtonColor: #fdb448;
    --emptyCategoryColor: #fdb448;
    --inputRadiusErrorOpen: 30px 30px 0 0;
    --gamesCategoriesQuickCategoriesLinkHoverColor: #fdb448;


    }


    .icon {
        cursor: pointer;
        width: 42px;
        height: 20px;
        fill: #fff;
        padding: 0px 10px;
        margin: 0px 10px;
        &.dark {
            fill: #fff;
        }
        @media(max-width: 768px){
            margin-left: 0px;
        }
    }
    .invalid-feedback {
        margin-top: 0;
    }



    //------------ Input -----------------

    .react-tel-input .form-control {
        width: 100% !important;
        background-color: transparent;
        border: none !important;
        background-color: var(--inputbgABC) !important;
        color: var(--tabletext) !important;
        border-radius: 25px;
        padding: 0 !important;
        font-size: 0.875rem;
        &:focus,
        &.open {
            color: var(--tabletext);
            background-color: transparent;
            border-color: var(--brandcolor);
            outline: 0;
            box-shadow: 0 0 0 0 rgba(0, 123, 255, 0.25);
        }
        }
        .react-tel-input {
        .flag-dropdown {
            /* height: calc(1.5em + 1.5rem + 3px); */
        }
        input:disabled {
            background-color: var(--bgColorABC) !important;
            border: 1px solid var(--inputbgABC) !important;
        }
    }
    
    input:-webkit-autofill,
    input:-webkit-autofill:hover, 
    input:-webkit-autofill:focus,
    textarea:-webkit-autofill,
    textarea:-webkit-autofill:hover,
    textarea:-webkit-autofill:focus,
    select:-webkit-autofill,
    select:-webkit-autofill:hover,
    select:-webkit-autofill:focus {
    border: 1px solid inherit;
    -webkit-text-fill-color: #07415F;
    -webkit-box-shadow: 0 0 0px 1000px #fffcc8 inset;
    box-shadow: 0 0 0px 1000px #fffcc8 inset;
    }
    input[type="text"]:disabled {
        color: #576064;
        background-color: transparent;
    }
    input[type="text"]:read-only {
        /* color: var(--tabletext); */
        // color: #0554b3;
        /* background-color: inherit; */
    }

    .lobby-loader {
        width: 100%;
        height: 100%;
    }

    .headersvgclass.game {
    fill: var(--switchfill);
    }

    /* .header {
    width: calc(100% - 330px) !important;
    }
    */


    // ---------- Typography -----------

    a,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    label,
    .button,
    body {
    font-family: "Chillax", Fallback, sans-serif;
    }
    h3,
    h4,
    h5 {
    color: var(--switchfill);
    }
    h6 {
    font-size: 14px;
    font-weight: 500;
    color: var(--carouseltext);
    }
    h2 {
    font-weight: 500;
    color: #0554b3;
    }
    @media (max-width: 770px) {
    h6 {
        font-size: 12px;
    }
    }

    h3 {
    display: block;
    font-weight: 500;
    font-size: 18px;
    line-height: 20px;
    white-space: pre-line;
    text-align: center;
    }
    p {
    display: inline;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    white-space: pre-line;
    text-align: left;
    color: var(--pcolor);
    }

    @media (min-width: 300px) {
    h3 {
       /*  font-size: 12px;
        line-height: 14px; */
        color: var(--aboutH2Color);
    }
    p {
        font-size: 15px;
        line-height: 21px;
        text-align: left;
    }
    }
    @media (min-width: 600px) {
    h3 {
        font-size: 14px;
        line-height: 16px;
    }
    p {
        font-size: 16px;
        line-height: 23px;
        text-align: justify;
    }
    }
    @media (min-width: 800px) {
    p {
        font-size: 16px;
        line-height: 24px;
    }
    }
    @media (min-width: 1000px) {
    h3 {
        font-size: 17px;
        line-height: 26px;
    }
    p {
        font-size: 16px;
        line-height: 22px;
    }
    }
    @media (min-width: 1200px) {
    p {
        font-size: 16px;
        line-height: 28px;
    }
    }

    /* @font-face {
    font-family: 'TT Norms Pro';
    font-weight: 500;
    font-display: swap;
    src: url('../data/fonts/TT-Norms-Pro-Light.woff') format('woff');
    }

    @font-face {
    font-family: 'TT Norms Pro';
    font-weight: 550;
    font-display: swap;
    src: url('../data/fonts/TT-Norms-Pro-Regular.woff') format('woff');
    }

    @font-face {
    font-family: 'TT Norms Pro';
    font-weight: 700;
    font-display: swap;
    src: url('../data/fonts/TT-Norms-Pro-Bold.woff') format('woff');
    }

    @font-face {
    font-family: 'TT Norms Pro';
    font-weight: 800;
    font-display: swap;
    src: url('../data/fonts/TT-Norms-Pro-ExtraBold.woff') format('woff');
    }

    @font-face {
    font-family: 'TT Norms Pro';
    font-weight: 900;
    font-display: swap;
    src: url('../data/fonts/TT-Norms-Pro-Black.woff') format('woff');
    } */


    // ------------ FORM ---------------
    .form-inline {
    display: flex;
    flex-flow: row wrap;
    align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)

    // Because we use flex, the initial sizing of checkboxes is collapsed and
    // doesn't occupy the full-width (which is what we want for xs grid tier),
    // so we force that here.
    .form-check {
        width: 100%;
    }

    // Kick in the inline
    @media (min-width: 576px) {
        label {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0;
        }

        // Inline-block all the things for "inline"
        .form-group {
        display: flex;
        flex: 0 0 auto;
        flex-flow: row wrap;
        align-items: center;
        margin-bottom: 0;
        }

        // Allow folks to *not* use 
        .form-control {
        display: inline-block;
        width: auto; // Prevent labels from stacking above inputs in 
        vertical-align: middle;
        }
        
        // Make static controls behave like regular ones
        .form-control-plaintext {
        display: inline-block;
        }

        .input-group,
        .custom-select {
        width: auto;
        }

        // Remove default margin on radios/checkboxes that were used for stacking, and
        // then undo the floating of radios and checkboxes to match.
        .form-check {
        display: flex;
        align-items: center;
        justify-content: center;
        width: auto;
        padding-left: 0;
        }
        .form-check-input {
        position: relative;
        flex-shrink: 0;
        margin-top: 0;
        margin-right: $form-check-input-margin-x;
        margin-left: 0;
        }

        .custom-control {
        align-items: center;
        justify-content: center;
        }
        .custom-control-label {
        margin-bottom: 0;
        }
    }
    }
        .bnt-logout {
            display:none;
        }

        .bnt-logout-profile {
            display:none;
        }



    // ----------- Nav Links ---------------

    .menu-main {
        font-weight: 600 !important;
        font-size: 24px !important;
        color: var(--mainmenu);
    }
    @media (max-height: 900px) {
        font-size: 20px !important;
    }
    @media (max-height: 600px) {
    .menu-main {
        font-size: 16px !important;
    }

    // --------- Active Bonus Info --------
    .bonus-info {
        button {
            font-size: 2rem !important;
        }
    }
}

`;
export default GlobalStyle;
